module.exports = __webpack_public_path__ + "static/media/qr.cd8b8c2a.png";